import React from "react";
import Link from "helpers/link";
import { formatDateGB } from "helpers/formatDate";

const BlogCard = ({
  showParagraph,
  fullWidth,
  bigHeading,
  blog: { author, date, title, description, image, handle, authorImage },
}) => {
  return (
    <Link
      to={`/content-hub/${handle.current}`}
      className={`flex-1 flex items-center ${
        fullWidth
          ? "flex-row gap-14 col-span-3 sm:flex-col sm:gap-5 sm:mb-5"
          : "flex-col gap-5"
      }`}
    >
      <div
        className={`rounded-lg overflow-hidden flex w-full ${
          !fullWidth ? "h-[280px]" : "flex-1"
        }`}
      >
        <img
          src={image?.src || authorImage?.src}
          alt={image?.alt || authorImage?.alt}
          className="w-full object-cover"
        />
      </div>
      <div className="flex-1 sm:flex-none w-full">
        <div className="flex items-center justify-start">
          <h3 className="paragraph text-gray-800">{author}</h3>
          <div className="w-10 h-px bg-gray-500 mx-4" />
          <span className="paragraph text-gray-600">{formatDateGB(date)}</span>
        </div>
        <h2
          className={`font-display font-bold  text-indigo-800 ${
            bigHeading
              ? "text-h1 mt-8 sm:text-xl sm:leading-normal sm:mt-3"
              : "text-h2 leading-normal mt-3 sm:text-xl"
          }`}
        >
          {title}
        </h2>
        {showParagraph && (
          <p className="font-sans font-medium text-bsae text-gray-600 mt-4">
            {description}
          </p>
        )}
      </div>
    </Link>
  );
};

export default BlogCard;
